import 'isomorphic-fetch';

const generateId = () =>
  '_' +
  Math.random()
    .toString(36)
    .substr(2, 9);

const apiUrl =
  process.env.GATSBY_APP_TARGET === 'staging'
    ? 'https://api-staging.ferndecor.ru'
    : 'https://api.ferndecor.ru';

export function submitForm(params) {
  const id = generateId();
  const referrer = window.location.href;

  return Promise.all([
    submitApiForm({ ...params, id }),
    process.env.NODE_ENV !== 'development' && submitNetlifyForm({ ...params, id, referrer }),
  ]);
}

function submitNetlifyForm(params) {
  return fetch('/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: encode({ 'form-name': 'contact', message: JSON.stringify(params) }),
  });
}

function submitApiForm(params) {
  const path = params.type === 'feedback' ? '/feedback' : '/order';

  const url = `${apiUrl}${path}?${encode(params)}`;

  return fetch(url, { method: 'POST' });
}

const encode = (data) => {
  return Object.keys(data)
    .map((key) => {
      if (!data[key]) {
        return undefined;
      }
      return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    })
    .filter((v) => v !== undefined)
    .join('&');
};
